import { HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { getTraceIdFromLogrocketSessionUrl } from '../helpers/getTraceIdFromLogrocketSessionUrl'
import { LogrocketPFFacade } from '../../shared/services/logrocket-pf-facade.service'

export const traceInterceptor: HttpInterceptorFn = (req, next) => {
  const logrocketPFFacade = inject(LogrocketPFFacade)
  const logrocketSessionUrl = logrocketPFFacade.getLogrocketSessionUrl()

  if (logrocketSessionUrl) {
    const trace = getTraceIdFromLogrocketSessionUrl(logrocketSessionUrl)
    if (trace) {
      if (!req.url.includes('biot')) {
        logrocketPFFacade.logrocketDebug(trace.traceWithSpanLink)
      }
      req = req.clone({
        setHeaders: {
          traceparent: trace.traceId,
          'X-Cloud-Trace-Context': trace.xCloudTraceContext
        }
      })
    }
  }
  return next(req)
}
